// Schrittleiste mit Balken (Handoff Übergabe §4): je Schritt ein Balken (erledigt ok, aktiv Akzent, offen fill3),
// darunter Nummer bzw. Haken und das Label (Label erst ab 760 px Breite). Klickbar nur mit `onWahl`.
import { Check } from '@phosphor-icons/react';

export function BalkenSchritte({ labels, aktuell, mitLabel, onWahl }: {
  labels: readonly string[];
  /** 1-basiert */
  aktuell: number;
  /** Labels anzeigen (ab 760 px) */
  mitLabel: boolean;
  /** Optional: Schritte antippbar (Hausmeister-App). Ohne bleibt die Leiste reine Anzeige. */
  onWahl?: (schritt: number) => void;
}) {
  return (
    <ol aria-label="Schritte" className="m-0 grid list-none p-0" style={{ gap: 6, gridTemplateColumns: `repeat(${labels.length}, minmax(0, 1fr))` }}>
      {labels.map((label, i) => {
        const n = i + 1;
        const erledigt = n < aktuell;
        const aktiv = n === aktuell;
        const farbe = erledigt ? 'var(--ok)' : aktiv ? 'var(--acc)' : 'var(--fill3, var(--fill2))';
        return (
          <li key={label} aria-current={aktiv ? 'step' : undefined} className="flex min-w-0 flex-col" style={{ gap: 8, position: 'relative' }}>
            {onWahl && (
              <button type="button" onClick={() => onWahl(n)} data-tip={`Schritt ${n} · ${label}`} aria-label={`Schritt ${n} · ${label}`}
                style={{ position: 'absolute', inset: '-6px -3px', border: 'none', background: 'transparent', cursor: 'pointer', borderRadius: 10, zIndex: 1 }} />
            )}
            <span aria-hidden style={{ height: 5, borderRadius: 3, background: farbe }} />
            <span className="flex min-w-0 items-center" style={{ gap: 6, justifyContent: mitLabel ? 'flex-start' : 'center' }}>
              <span className="inline-flex shrink-0 items-center justify-center tabular-nums"
                style={{ width: 22, height: 22, borderRadius: '50%', fontSize: 11, fontWeight: 800,
                  background: erledigt ? 'var(--ok)' : aktiv ? 'var(--acc-fill)' : 'var(--fill2)',
                  color: erledigt ? '#fff' : aktiv ? 'var(--acc-ink)' : 'var(--ink3)' }}>
                {erledigt ? <Check size={12} weight="bold" /> : n}
              </span>
              {mitLabel && (
                <span className="truncate" style={{ fontSize: 13, fontWeight: aktiv ? 800 : 600, color: erledigt ? 'var(--ok)' : aktiv ? 'var(--ink)' : 'var(--ink3)' }}>{label}</span>
              )}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
